<template>
    <div
        v-if="blok"
        v-editable="blok"
        class="two-columns grid gap-6 md:grid-cols-2"
    >
        <div>
            <RichText v-if="blok.left_text" :rich-text="blok.left_text" />
        </div>
        <div>
            <RichText v-if="blok.right_text" :rich-text="blok.right_text" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { TwoColumnsStoryblok } from '~/app/types/storyblok-types';
import RichText from '../ui/RichText.vue';

defineProps<{ blok: TwoColumnsStoryblok }>();
</script>

<style>
@reference "../../assets/css/main.css";
.two-columns p {
    @apply last:mb-0;
}
.two-columns + .two-columns {
    @apply mt-6;
}
</style>
